export default __webpack_public_path__ + "static/media/joel-muniz-3k3l2brxmwQ-unsplash.969f12b1.jpg";